import get from "lodash/get";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import StarRatingComponent from "Library/react-star-rating-component";
import { instance } from "../../../../Actions/AxiosInstance";
import { ValidateDropdown } from "../../../../Utils/Validation";
import addressEmployee from "../../../../Assets/Images/skills.svg";
import createstore from "../../../../store";
import EmpSkillForm from "./EmpSkillForm";
import CreateComp from "../create";
import If from "../../../../Component/Common/If";
import { NoRecordFound } from "./NoRecordFound";

class EmpSkill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 0,
      skill: "",
      flag: 3,
      skills: [],
      successFlag: false,
      hideButton: false,
      dataReceived: false,
    };
  }

  componentDidMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
      },
      () => {
        this.GetSkills();
      },
    );
  }

  SetFlag(value, success, e) {
    const flag = value;
    const successFlag = success;
    this.setState({ flag, SkillDetails: {}, successFlag }, () => {
      if (flag != 1) this.GetSkills();
      this.props.UpdateStrength(true);
    });
  }

  GetSkills() {
    const URL = "employee/getempallskill";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        // result.data.result.length > 0 ? (skills = result.data.result) : (skills = []);
        // let defaultmsg;
        // result.data.result.length <= 0 ? (defaultmsg = true) : (defaultmsg = false);
        // this.setState({ skills, defaultmsg });

        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            skills: result.data.result,
            dataReceived: true,
            flag: 3,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularSkillDetails(value, data, e) {
    const SkillDetails = data;
    const flag = value;
    this.setState({ SkillDetails, flag });
  }

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    list[name] = selectedItem;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";

    this.setState({ list, name });

    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList });
      ValidateDropdown(this.state, name);
    }
  }

  DeleteEmpSkills = (item) => {
    const URL = `employee/empskill/${item.employeeskillid}`;
    instance
      .post(URL)
      .then((resp) => {
        this.props.enqueueSnackbar("Deleted Successfully", {
          variant: "success",
        });
        this.GetSkills();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  Deleteconfirmation = (item) => {
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => this.DeleteEmpSkills(item)}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small">
          Cancel
        </Button>,
      ],
    });
  };

  render() {
    let model;
    const { flag } = this.state;
    const { hideButton, dataReceived } = this.state;
    if (flag === 0) {
      model = (
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {!hideButton ? (
                <CreateComp
                  text="Things that make you special"
                  heading={
                    <FormattedMessage id="LbSkills" defaultMessage="Skills" />
                  }
                  onCreate={this.SetFlag.bind(this, 1, false)}
                  imageSrc={addressEmployee}
                />
              ) : (
                <NoRecordFound />
              )}
            </Grid>
          </Grid>
        </div>
      );
    }

    if (flag === 1) {
      model = (
        <div>
          <EmpSkillForm
            SetFlag={this.SetFlag.bind(this)}
            data={this.state.SkillDetails}
            {...this.props}
          />
        </div>
      );
    }

    if (flag === 2) {
      model = (
        <div>
          <p className="input-form-label address-label">
            {" "}
            <FormattedMessage
              id="LbotherSkillDetailsYouWanttoadd"
              defaultMessage="Would you like to add another skill details too?"
            />{" "}
          </p>
          <div
            className="form-btn form-control margin-right-20"
            onClick={this.SetFlag.bind(this, 1, false)}
          >
            <FormattedMessage id="Btyes" defaultMessage="Yes" />
          </div>
          <div
            className="form-btn form-control"
            onClick={this.SetFlag.bind(this, 3, false)}
          >
            <FormattedMessage id="Btno" defaultMessage="No" />
          </div>
        </div>
      );
    }

    if (flag === 3) {
      model = (
        <div className="profile-data-view-page">
          {/* {this.state.successFlag ?
            <p class="input-form-label address-label"> <FormattedMessage
                id="Lbbanksuccessscreen"
                defaultMessage="Congratulations! you have added your skill details successfully. Kindly review your skill details"
            /> </p> : ''} */}
          {this.state.skills.length > 0 ? (
            <div className="width100">
              <div>
                {/* <Button variant="contained" onClick={this.SetFlag.bind(this, 1)} color="primary">+</Button> */}
                {this.state.skills.map((data) => (
                  <div>
                    <div className="padding-bottom-10 position-rel">
                      <div className="inlineClass">
                        <p className="address-data">
                          <span className="floatleft margin-right-16">
                            {data.skill}
                          </span>
                          <span>
                            <StarRatingComponent
                              name="rate1"
                              starCount={5}
                              value={data.rating}
                              starColor="#166ab3"
                              className="aaa"
                            />
                          </span>
                        </p>
                      </div>
                      <If condition={!hideButton}>
                        <div>
                          <svg
                            className={"address-edit cursour-pointer"}
                            onClick={this.GetPerticularSkillDetails.bind(
                              this,
                              1,
                              data,
                            )}
                            width="24"
                            style={{ marginRight: 40 }}
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                          </svg>
                          <svg
                            className={"address-edit cursour-pointer"}
                            onClick={() => this.Deleteconfirmation(data)}
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                            <path fill="none" d="M0 0h24v24H0V0z" />
                          </svg>
                        </div>
                      </If>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <NoRecordFound />
          )}
          {!hideButton && (
            <div
              className={
                this.state.hideButton ? "hide-button" : "add-more-button"
              }
              onClick={this.SetFlag.bind(this, 1, false)}
            >
              <Button variant="contained" color="primary" className="no-shadow">
                Add More
              </Button>
            </div>
          )}
        </div>
      );
    }

    return (
      <If condition={dataReceived}>
        <div>{model}</div>
      </If>
    );
  }
}

export default withSnackbar(EmpSkill);
